var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeigungGrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Neigung_Grade__Icn/40px/Neigung_Grade",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Neigung_Grade__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Neigung_Grade__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5,31 L35,31 L35,33 L5,33 L5,31 Z M21,6 L20.9993841,25.568 L23.4826655,23.0857864 L24.8968791,24.5 L19.9471316,29.4497475 L14.9973841,24.5 L16.4115977,23.0857864 L18.9993841,25.674 L19,6 L21,6 Z",
    id: ".._.._src_svg_Icn_40px_Neigung_Grade__Combined-Shape-Copy"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeigungGrade);
export default __webpack_public_path__ + "static/media/Neigung_Grade.845e2370aeeea12697db2d3cf0e29bdc.svg";
export { ForwardRef as ReactComponent };